// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__AR9cX","modal__footer":"styles_modal__footer__+VHoq"};